import React, { useEffect, useState } from 'react';
import SearchItemBlock from '../../shared/SearchItemBlock';
import { useTranslation } from 'react-i18next';
import PreferencesList from './PreferencesList';
import PreferenceItemsTable from './PreferenceItemsTable';
import PreferencePhraseSwitcher from './PreferencePhraseSwitcher';
import { preferencesStorageInstance as preferencesStorage } from '../../services/preferencesStorage';
import CreateNewPreferenceButton from './CreateNewPreferenceButton';
import DeletePreferencePopup from './DeletePreferencePopup';
import PreferencesListActions from './PreferencesListActions';
import AssignGroupToPreferencePopup from './AssignGroupToPreferencePopup';
import { useListViewMode } from '../../shared/listView/useListViewMode';
import ListViewSwitcher from '../../shared/listView/ListViewSwitcher';
import { preferencesGroupsStorage } from '../../services/preferencesGroupsStorage';

const PreferenceItemsTab = () => {
    const { i18n } = useTranslation();
    const { mode, setMode, isTableForcedOff } = useListViewMode('preference-item', { defaultMode: 'tile' });
    const [revision, setRevision] = useState(0);
    const [ready, setReady] = useState(false);

    const handleLoadPreference = () => {
        preferencesStorage.loadItems(() => setRevision((value) => value + 1));
    };

    useEffect(() => {
        const onChange = () => {
            setReady(true);
            setRevision((value) => value + 1);
        };
        preferencesGroupsStorage.loadItems(() => {});
        preferencesStorage.loadItems(onChange);
        preferencesStorage.registerFiltersChangingObserver(onChange);
        return () => {
            preferencesStorage.unRegisterFiltersChangingObserver(onChange);
            preferencesStorage.cleanSelectedPreferences();
            preferencesStorage.clearService();
        };
    }, []);

    return (
        <React.Fragment>
            <DeletePreferencePopup notifyPreferencesList={handleLoadPreference} />
            <AssignGroupToPreferencePopup notifyPreferencesList={handleLoadPreference} />
            <SearchItemBlock
                itemsStorageService={preferencesStorage}
                placeholder={i18n.t('app.page.preference.preferenceSearch')}
                actions={
                    <>
                        <CreateNewPreferenceButton />
                        <ListViewSwitcher
                            mode={mode}
                            onChange={setMode}
                            disabled={isTableForcedOff}
                        />
                    </>
                }
            />
            <article className="preference__article preference__article_full-width">
                <div className="preference__groups-block">
                    <PreferencePhraseSwitcher pageUrl={'/preference/phrase/list'} itemTitle={i18n.t('app.page.preference.item')} />
                    <PreferencesListActions/>
                </div>
                {mode === 'table' ? (
                    <PreferenceItemsTable key={`table-${revision}`} items={ready ? preferencesStorage.getItems() : []} />
                ) : (
                    <PreferencesList key={`tile-${revision}`} skipLoad />
                )}
            </article>
        </React.Fragment>
    );
};

export default PreferenceItemsTab;
